import { confirm } from "components/Confirmation";
import IconButton from "components/IconButton";
import ModalHistoricoLogs from "components/ModalHistoricoLogs";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Table } from "reactstrap";
import contratoService from "services/ContratoService";

export default function Aditivos({ idContrato, edit }) {
  const [itens, setItens] = useState([])
  const [modalLog, setModalLog] = useState({ isOpen: false, idRegistro: null, titulo: '' })
  const [exibirInativos, setExibirInativos] = useState(false)
  const navigate = useNavigate()

  const carregar = useCallback(() => {
    contratoService.listarAditivos(idContrato, true).then(res => {
      if (res.success) {
        setItens(res.data)
      }
    })
  }, [idContrato])

  useEffect(() => {
    carregar()
  }, [idContrato, carregar])

  const handleDelete = (item) => {
    confirm({
      header: "Excluir aditivo",
      text: `Tem certeza que deseja excluir o aditivo "${item.numero} - ${item.descricao}" deste contrato?`,
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await contratoService.excluirAditivo(idContrato, item.id)
          if (res.success) {
            carregar()
            toast("Aditivo excluído")
          } else {
            toast("Erro ao excluir o aditivo")
          }
        } catch (ex) {
          toast("Erro ao excluir o aditivo")
        }
      }
    })
  }

  const handleRestore = (item) => {
    confirm({
      header: "Restaurar aditivo",
      text: `Tem certeza que deseja restaurar o aditivo "${item.numero} - ${item.descricao}" deste contrato?`,
      icon: "bi-arrow-counterclockwise",
      onConfirm: async () => {
        try {
          const res = await contratoService.restaurarAditivo(idContrato, item.id)
          if (res.success) {
            carregar()
            toast("Aditivo restaurado")
          } else {
            toast("Erro ao restaurar o aditivo")
          }
        } catch (ex) {
          toast("Erro ao restaurar o aditivo")
        }
      }
    })
  }

  const inativosCount = itens.filter(el => el.ativo === false).length
  const showExibirInativosControl = edit === true && inativosCount > 0

  useEffect(() => {
    if (!showExibirInativosControl && exibirInativos) {
      setExibirInativos(false)
    }
  }, [showExibirInativosControl, exibirInativos])

  const itensVisiveis = exibirInativos
    ? itens
    : itens.filter(el => el.ativo !== false)

  return (
    <>
      <div>
      <div className="d-flex justify-content-end mb-2">
        <div className="text-right">
          <Link className="btn btn-primary btn-icon" to={`/admin/contratos/${idContrato}/aditivos/novo/passo1`}>Criar Aditivo</Link>
        </div>
      </div>
      {showExibirInativosControl && (
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="text-muted small mr-3">
            {exibirInativos
              ? `Exibindo ${inativosCount} aditivo(s) excluído(s)`
              : `Ocultando ${inativosCount} aditivo(s) excluído(s)`}
          </div>
          <div className="d-flex align-items-center mb-0 gap-5px">
            <div>Exibir excluídos</div>
            <label className="custom-toggle" style={{ marginBottom: 0 }}>
              <input
                type="checkbox"
                id="exibirInativosAditivos"
                checked={exibirInativos}
                onChange={e => setExibirInativos(e.target.checked)}
              />
              <span className="custom-toggle-slider rounded-circle" />
            </label>
          </div>
        </div>
      )}
      <Table className="align-items-center table-flush">
        <thead>
          <tr>
            <th>Número</th>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Início Vigência</th>
            <th>Itens Afetados</th>
            <th>Status</th>
            <th style={{ width: 120 }}></th>
          </tr>
        </thead>
        <tbody>
          {itensVisiveis.map(el => {
            const isActive = el.ativo !== false
            return (
              <tr key={el.id} className={!isActive ? 'text-muted' : ''}>
                <td>{el.numero}</td>
                <td>{el.tipoFmt}</td>
                <td>
                  {el.descricao}
                  {!isActive && <span className="badge badge-danger ml-2">Excluído</span>}
                </td>
                <td>{el.inicioVigenciaFmt}</td>
                <td>{el.itensAfetados}</td>
                <td>{el.statusFmt}</td>
                <td className="d-flex flex-row gap-5px">
                  {isActive && <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate(`/admin/contratos/${idContrato}/aditivos/${el.id}`)} />}
                  <IconButton alt="LOG" iconClass="bi-clock-history" onClick={() => setModalLog({ isOpen: true, idRegistro: el.id, titulo: `LOG: Aditivo ${el.numero}` })} />
                  {edit && isActive && !el.vigente && (
                    <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                  )}
                  {edit && !isActive && (
                    <IconButton alt="Restaurar" iconClass="bi-arrow-counterclockwise" onClick={() => handleRestore(el)} />
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
      </div>

      <ModalHistoricoLogs
        isOpen={modalLog.isOpen}
        toggle={() => setModalLog(p => ({ ...p, isOpen: false }))}
        tipo="aditivo"
        idRegistro={modalLog.idRegistro}
        titulo={modalLog.titulo}
      />
    </>
  )
}
